import ApiService from '@/common/api.service';

export const IndicatorService = {
    get() {
        return ApiService.query('/pai/indicator');
    }
};
